import { render, staticRenderFns } from "./SelectTicketType.vue?vue&type=template&id=368b4a38&scoped=true&"
import script from "./SelectTicketType.vue?vue&type=script&lang=js&"
export * from "./SelectTicketType.vue?vue&type=script&lang=js&"
import style0 from "./SelectTicketType.vue?vue&type=style&index=0&id=368b4a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368b4a38",
  null
  
)

export default component.exports